<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Module" subTitle="Forms" />

    <CreateModule />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateModule from "@/components/Pages/Master/Module/CreateModule.vue";

export default defineComponent({
  name: "CreateModulePage",
  components: {
    PageTitle,
    CreateModule,
  },
});
</script>
